import React, { useState, useEffect } from "react";
import '../style_new.css';
const imgbaseUrl = `${process.env.PUBLIC_URL}/images/`;

const imageCount = 20;

const images = Array.from({ length: imageCount }, (_, i) => `project-${i + 1}.jpg`);

const ProjectSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const imagesPerSlide = 2;

  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex + imagesPerSlide >= images.length ? 0 : prevIndex + imagesPerSlide
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex - imagesPerSlide < 0
        ? images.length - imagesPerSlide
        : prevIndex - imagesPerSlide
    );
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000); // 5 seconds
    return () => clearInterval(interval); // cleanup
  }, []);

  const visibleImages = images.slice(currentIndex, currentIndex + imagesPerSlide);

  return (
    <div className="slider-container">
      <button onClick={prevSlide} className="slider-button">←</button>

      <div className="slider-wrapper">
        {visibleImages.map((img,  i) => (
          <img
            key={i}
            src={`${imgbaseUrl}${img}`}
            alt={`Slide ${i +1} `}
            className="slider-image"
          />
        ))}
      </div>

      <button onClick={nextSlide} className="slider-button">→</button>
    </div>
  );
};

export default ProjectSlider;
